// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { AffectedDependent, AnalysisSpecItem, AnalysisSpecLineageResponse, AnalysisSpecPayload, AnalysisSpecProgressEvent, AnalysisSpecProgressResponse, AnalysisSpecResponse, AnalysisSpecStatusResponse, BlockedSourceTablesResponse, DefinitionImpactResponse, DeleteAnalysisSpecResponse, DependentDashboardsResponse, DuplicateAnalysisSpecResponse, ExportAnalysisSpecResponse, ExportDownloadResponse, ListAnalysisSpecsResponse, RefreshAnalysisSpecDataResponse, RegenerateAnalysisSpecQueryResponse, ReplaceAnalysisSpecDefinitionResponse, UpdateAnalysisSpecSourceTablesResponse } from "../analysisSpec/dto.generated";
import type { SourceAuditColumn, SourceAuditReport, SourceColumn, SourceTable } from "../etlSource/dto.generated";
import type { ETLErrorCategory, ETLErrorConnector, ETLErrorInfo, ETLErrorReason, ETLErrorRemediation } from "../etlTasks/domain.generated";
import type { GoldRefreshHealth, GoldRefreshState } from "../goldRefreshHealth/domain.generated";
export const addTagTypes = ["analysis-specs"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiAnalysisSpecsExportDownload: build.query<
        GetApiAnalysisSpecsExportDownloadApiResponse,
        GetApiAnalysisSpecsExportDownloadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/analysis-specs/export-download`,
          params: {
            token: queryArg.token,
          },
        }),
        providesTags: ["analysis-specs"],
      }),
      getApiProjectsByProjectIdAnalysisSpecs: build.query<
        GetApiProjectsByProjectIdAnalysisSpecsApiResponse,
        GetApiProjectsByProjectIdAnalysisSpecsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs`,
          params: {
            limit: queryArg.limit,
            cursor: queryArg.cursor,
            latest: queryArg.latest,
          },
        }),
        providesTags: ["analysis-specs"],
      }),
      postApiProjectsByProjectIdAnalysisSpecs: build.mutation<
        PostApiProjectsByProjectIdAnalysisSpecsApiResponse,
        PostApiProjectsByProjectIdAnalysisSpecsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs`,
          method: "POST",
          body: queryArg.analysisspecCreateAnalysisSpecRequest,
        }),
        invalidatesTags: ["analysis-specs"],
      }),
      getApiProjectsByProjectIdAnalysisSpecsBySlugAndSlug: build.query<
        GetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugApiResponse,
        GetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/by-slug/${encodeURIComponent(String(queryArg.slug))}`,
        }),
        providesTags: ["analysis-specs"],
      }),
      getApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugLineage: build.query<
        GetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugLineageApiResponse,
        GetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugLineageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/by-slug/${encodeURIComponent(String(queryArg.slug))}/lineage`,
        }),
        providesTags: ["analysis-specs"],
      }),
      getApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugProgress: build.query<
        GetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugProgressApiResponse,
        GetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugProgressApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/by-slug/${encodeURIComponent(String(queryArg.slug))}/progress`,
          params: {
            limit: queryArg.limit,
          },
        }),
        providesTags: ["analysis-specs"],
      }),
      getApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugStatus: build.query<
        GetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugStatusApiResponse,
        GetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/by-slug/${encodeURIComponent(String(queryArg.slug))}/status`,
        }),
        providesTags: ["analysis-specs"],
      }),
      putApiProjectsByProjectIdAnalysisSpecsInstructions: build.mutation<
        PutApiProjectsByProjectIdAnalysisSpecsInstructionsApiResponse,
        PutApiProjectsByProjectIdAnalysisSpecsInstructionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/instructions`,
          method: "PUT",
          body: queryArg.domainInstructionRequest,
        }),
        invalidatesTags: ["analysis-specs"],
      }),
      postApiProjectsByProjectIdAnalysisSpecsInstructions: build.mutation<
        PostApiProjectsByProjectIdAnalysisSpecsInstructionsApiResponse,
        PostApiProjectsByProjectIdAnalysisSpecsInstructionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/instructions`,
          method: "POST",
          body: queryArg.domainInstructionRequest,
        }),
        invalidatesTags: ["analysis-specs"],
      }),
      deleteApiProjectsByProjectIdAnalysisSpecsInstructions: build.mutation<
        DeleteApiProjectsByProjectIdAnalysisSpecsInstructionsApiResponse,
        DeleteApiProjectsByProjectIdAnalysisSpecsInstructionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/instructions`,
          method: "DELETE",
          body: queryArg.domainDeleteInstructionRequest,
        }),
        invalidatesTags: ["analysis-specs"],
      }),
      patchApiProjectsByProjectIdAnalysisSpecsInstructions: build.mutation<
        PatchApiProjectsByProjectIdAnalysisSpecsInstructionsApiResponse,
        PatchApiProjectsByProjectIdAnalysisSpecsInstructionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/instructions`,
          method: "PATCH",
          body: queryArg.domainInstructionRequest,
        }),
        invalidatesTags: ["analysis-specs"],
      }),
      deleteApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecName:
        build.mutation<
          DeleteApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameApiResponse,
          DeleteApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/${encodeURIComponent(String(queryArg.analysisSpecName))}`,
            method: "DELETE",
          }),
          invalidatesTags: ["analysis-specs"],
        }),
      patchApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecName:
        build.mutation<
          PatchApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameApiResponse,
          PatchApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/${encodeURIComponent(String(queryArg.analysisSpecName))}`,
            method: "PATCH",
            body: queryArg.analysisspecUpdateAnalysisSpecDescriptionRequest,
          }),
          invalidatesTags: ["analysis-specs"],
        }),
      getApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameBlockedSourceTables:
        build.query<
          GetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameBlockedSourceTablesApiResponse,
          GetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameBlockedSourceTablesApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/${encodeURIComponent(String(queryArg.analysisSpecName))}/blocked-source-tables`,
          }),
          providesTags: ["analysis-specs"],
        }),
      putApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDefinition:
        build.mutation<
          PutApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDefinitionApiResponse,
          PutApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDefinitionApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/${encodeURIComponent(String(queryArg.analysisSpecName))}/definition`,
            method: "PUT",
            body: queryArg.analysisspecReplaceAnalysisSpecDefinitionRequest,
          }),
          invalidatesTags: ["analysis-specs"],
        }),
      postApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDefinitionImpact:
        build.mutation<
          PostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDefinitionImpactApiResponse,
          PostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDefinitionImpactApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/${encodeURIComponent(String(queryArg.analysisSpecName))}/definition/impact`,
            method: "POST",
            body: queryArg.analysisspecDefinitionImpactRequest,
          }),
          invalidatesTags: ["analysis-specs"],
        }),
      getApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDependentDashboards:
        build.query<
          GetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDependentDashboardsApiResponse,
          GetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDependentDashboardsApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/${encodeURIComponent(String(queryArg.analysisSpecName))}/dependent-dashboards`,
          }),
          providesTags: ["analysis-specs"],
        }),
      postApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDuplicate:
        build.mutation<
          PostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDuplicateApiResponse,
          PostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDuplicateApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/${encodeURIComponent(String(queryArg.analysisSpecName))}/duplicate`,
            method: "POST",
          }),
          invalidatesTags: ["analysis-specs"],
        }),
      getApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameExport:
        build.query<
          GetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameExportApiResponse,
          GetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameExportApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/${encodeURIComponent(String(queryArg.analysisSpecName))}/export`,
            params: {
              visibility: queryArg.visibility,
            },
          }),
          providesTags: ["analysis-specs"],
        }),
      postApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameRefresh:
        build.mutation<
          PostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameRefreshApiResponse,
          PostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameRefreshApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/${encodeURIComponent(String(queryArg.analysisSpecName))}/refresh`,
            method: "POST",
          }),
          invalidatesTags: ["analysis-specs"],
        }),
      postApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameRegenerateQuery:
        build.mutation<
          PostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameRegenerateQueryApiResponse,
          PostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameRegenerateQueryApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/${encodeURIComponent(String(queryArg.analysisSpecName))}/regenerate-query`,
            method: "POST",
            body: queryArg.analysisspecRegenerateAnalysisSpecQueryRequest,
          }),
          invalidatesTags: ["analysis-specs"],
        }),
      patchApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameSourceTables:
        build.mutation<
          PatchApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameSourceTablesApiResponse,
          PatchApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameSourceTablesApiArg
        >({
          query: (queryArg) => ({
            url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/analysis-specs/${encodeURIComponent(String(queryArg.analysisSpecName))}/source-tables`,
            method: "PATCH",
            body: queryArg.analysisspecUpdateAnalysisSpecSourceTablesRequest,
          }),
          invalidatesTags: ["analysis-specs"],
        }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as analysisSpecApi };
export type GetApiAnalysisSpecsExportDownloadApiResponse =
  /** status 200 OK */ { data: AnalysisspecExportDownloadResponse };
export type GetApiAnalysisSpecsExportDownloadApiArg = {
  /** Signed export link token */
  token: string;
};
export type GetApiProjectsByProjectIdAnalysisSpecsApiResponse =
  /** status 202 Accepted */ { data: AnalysisspecListAnalysisSpecsResponse };
export type GetApiProjectsByProjectIdAnalysisSpecsApiArg = {
  /** Project ID */
  projectId: string;
  /** Pagination limit */
  limit?: number;
  /** Pagination cursor */
  cursor?: string;
  /** Every spec at its latest version, unpaginated (limit and cursor are ignored) */
  latest?: boolean;
};
export type PostApiProjectsByProjectIdAnalysisSpecsApiResponse =
  /** status 201 Created */ { data: AnalysisspecAnalysisSpecResponse };
export type PostApiProjectsByProjectIdAnalysisSpecsApiArg = {
  /** Project ID */
  projectId: string;
  /** Analysis spec creation request */
  analysisspecCreateAnalysisSpecRequest: AnalysisspecCreateAnalysisSpecRequest;
};
export type GetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugApiResponse =
  /** status 200 OK */ { data: AnalysisspecAnalysisSpecResponse };
export type GetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugApiArg = {
  /** Project ID */
  projectId: string;
  /** Analysis spec slug */
  slug: string;
};
export type GetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugLineageApiResponse =
  /** status 200 OK */ { data: AnalysisspecAnalysisSpecLineageResponse[] };
export type GetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugLineageApiArg = {
  /** Project ID */
  projectId: string;
  /** Analysis spec slug */
  slug: string;
};
export type GetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugProgressApiResponse =
  /** status 200 OK */ { data: AnalysisspecAnalysisSpecProgressResponse };
export type GetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugProgressApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Analysis spec slug */
    slug: string;
    /** Max events to return (default 100, max 500) */
    limit?: number;
  };
export type GetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugStatusApiResponse =
  /** status 200 OK */ { data: AnalysisspecAnalysisSpecStatusResponse };
export type GetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugStatusApiArg = {
  /** Project ID */
  projectId: string;
  /** Analysis spec slug */
  slug: string;
};
export type PutApiProjectsByProjectIdAnalysisSpecsInstructionsApiResponse =
  /** status 200 OK */ { data: AnalysisspecAnalysisSpecResponse };
export type PutApiProjectsByProjectIdAnalysisSpecsInstructionsApiArg = {
  /** Project ID */
  projectId: string;
  /** Final instruction pack */
  domainInstructionRequest: DomainInstructionRequest;
};
export type PostApiProjectsByProjectIdAnalysisSpecsInstructionsApiResponse =
  /** status 201 Created */ { data: AnalysisspecAnalysisSpecResponse };
export type PostApiProjectsByProjectIdAnalysisSpecsInstructionsApiArg = {
  /** Project ID */
  projectId: string;
  /** Instruction creation request */
  domainInstructionRequest: DomainInstructionRequest;
};
export type DeleteApiProjectsByProjectIdAnalysisSpecsInstructionsApiResponse =
  /** status 200 OK */ { data: AnalysisspecAnalysisSpecResponse };
export type DeleteApiProjectsByProjectIdAnalysisSpecsInstructionsApiArg = {
  /** Project ID */
  projectId: string;
  /** Instruction deletion request */
  domainDeleteInstructionRequest: DomainDeleteInstructionRequest;
};
export type PatchApiProjectsByProjectIdAnalysisSpecsInstructionsApiResponse =
  /** status 200 OK */ { data: AnalysisspecAnalysisSpecResponse };
export type PatchApiProjectsByProjectIdAnalysisSpecsInstructionsApiArg = {
  /** Project ID */
  projectId: string;
  /** Instruction update request */
  domainInstructionRequest: DomainInstructionRequest;
};
export type DeleteApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameApiResponse =
  /** status 200 OK */ { data: AnalysisspecDeleteAnalysisSpecResponse };
export type DeleteApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Analysis spec name */
    analysisSpecName: string;
  };
export type PatchApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameApiResponse =
  /** status 200 OK */ { data: AnalysisspecAnalysisSpecResponse };
export type PatchApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Analysis spec name */
    analysisSpecName: string;
    /** Update request */
    analysisspecUpdateAnalysisSpecDescriptionRequest: AnalysisspecUpdateAnalysisSpecDescriptionRequest;
  };
export type GetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameBlockedSourceTablesApiResponse =
  /** status 200 OK */ { data: AnalysisspecBlockedSourceTablesResponse };
export type GetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameBlockedSourceTablesApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Analysis spec name */
    analysisSpecName: string;
  };
export type PutApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDefinitionApiResponse =
  /** status 202 Accepted */ { data: AnalysisspecReplaceAnalysisSpecDefinitionResponse };
export type PutApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDefinitionApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Analysis spec name */
    analysisSpecName: string;
    /** Replace definition request */
    analysisspecReplaceAnalysisSpecDefinitionRequest: AnalysisspecReplaceAnalysisSpecDefinitionRequest;
  };
export type PostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDefinitionImpactApiResponse =
  /** status 200 OK */ { data: AnalysisspecDefinitionImpactResponse };
export type PostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDefinitionImpactApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Analysis spec name */
    analysisSpecName: string;
    /** Candidate query */
    analysisspecDefinitionImpactRequest: AnalysisspecDefinitionImpactRequest;
  };
export type GetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDependentDashboardsApiResponse =
  /** status 200 OK */ { data: AnalysisspecDependentDashboardsResponse };
export type GetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDependentDashboardsApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Analysis spec name */
    analysisSpecName: string;
  };
export type PostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDuplicateApiResponse =
  /** status 202 Accepted */ { data: AnalysisspecDuplicateAnalysisSpecResponse };
export type PostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDuplicateApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Analysis spec name */
    analysisSpecName: string;
  };
export type GetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameExportApiResponse =
  /** status 200 OK */ { data: AnalysisspecExportAnalysisSpecResponse };
export type GetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameExportApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Analysis spec name */
    analysisSpecName: string;
    /** public (default) or private */
    visibility?: string;
  };
export type PostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameRefreshApiResponse =
  /** status 202 Accepted */ { data: AnalysisspecRefreshAnalysisSpecDataResponse };
export type PostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameRefreshApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Analysis spec name */
    analysisSpecName: string;
  };
export type PostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameRegenerateQueryApiResponse =
  /** status 202 Accepted */ { data: AnalysisspecRegenerateAnalysisSpecQueryResponse };
export type PostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameRegenerateQueryApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Analysis spec name */
    analysisSpecName: string;
    /** Analysis spec query regeneration request */
    analysisspecRegenerateAnalysisSpecQueryRequest: AnalysisspecRegenerateAnalysisSpecQueryRequest;
  };
export type PatchApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameSourceTablesApiResponse =
  /** status 202 Accepted */ { data: AnalysisspecUpdateAnalysisSpecSourceTablesResponse };
export type PatchApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameSourceTablesApiArg =
  {
    /** Project ID */
    projectId: string;
    /** Analysis spec name */
    analysisSpecName: string;
    /** Update source tables request */
    analysisspecUpdateAnalysisSpecSourceTablesRequest: AnalysisspecUpdateAnalysisSpecSourceTablesRequest;
  };
export type AnalysisspecExportDownloadResponse = ExportDownloadResponse;
export type DomainInstructionItem = {
  instruction_id?: string;
  text?: string;
};
export type DomainGoldRefreshState = GoldRefreshState;
export type DomainGoldRefreshHealth = GoldRefreshHealth;
export type EtlSourceSourceAuditColumn = SourceAuditColumn;
export type EtlSourceSourceAuditReport = SourceAuditReport;
export type EtlSourceSourceColumn = SourceColumn;
export type EtlSourceForeignKeyDescriptionDto = {
  constrained_columns?: string[];
  referred_columns?: string[];
  referred_table?: string;
};
export type EtlSourceSapHeaderDeltaConfigDto = {
  documents_per_call?: number;
  header_table?: string;
  header_where_clause?: string;
  link_columns?: string[];
  max_documents?: number;
  max_table_ratio?: number;
};
export type EtlSourceWindowReloadConfigDto = {
  column?: string;
  from?: string;
  min_ratio?: number;
  to?: string;
};
export type EtlSourceIncrementalConfigDto = {
  created_column?: string;
  deleted_column?: string;
  full_load_min_ratio?: number;
  /** See domain.SapHeaderDeltaConfig: set instead of UpdateColumn for a detail table whose window
    comes from a header table. Leading, for govet's fieldalignment. */
  header_delta?: EtlSourceSapHeaderDeltaConfigDto;
  lookback_minutes?: number;
  merge_key?: string;
  update_column?: string;
  /** See domain.WindowReloadConfig: set instead of MergeKey/UpdateColumn — the one profile with no
    merge key. */
  window?: EtlSourceWindowReloadConfigDto;
};
export type EtlSourceSourceTable = SourceTable;
export type AnalysisspecAnalysisSpecItem = AnalysisSpecItem;
export type AnalysisspecListAnalysisSpecsResponse = ListAnalysisSpecsResponse;
export type EtlSourceColumnDescriptionDto = {
  description?: string;
  name: string;
  type?: string;
};
export type EtlSourceTableDescriptionDto = {
  columns: EtlSourceColumnDescriptionDto[];
  description?: string;
  foreign_keys?: EtlSourceForeignKeyDescriptionDto[];
  incremental?: EtlSourceIncrementalConfigDto;
  layer_id?: string;
  name: string;
  not_null_columns?: string[];
  primary_keys?: string[];
  unique_columns?: string[];
};
export type AnalysisspecAnalysisSpecPayload = AnalysisSpecPayload;
export type AnalysisspecAnalysisSpecResponse = AnalysisSpecResponse;
export type DomainAuditColumn = {
  change?: string;
  column?: string;
  reason?: string;
};
export type DomainAuditReport = {
  columns?: DomainAuditColumn[];
};
export type DomainColumnDescription = {
  description?: string;
  name?: string;
  table_id?: string;
  type?: string;
};
export type DomainForeignKeyDescription = {
  constrained_columns?: string[];
  referred_columns?: string[];
  referred_table?: string;
};
export type DomainSapHeaderDeltaConfig = {
  documents_per_call?: number;
  header_table?: string;
  header_where_clause?: string;
  link_columns?: string[];
  max_documents?: number;
  /** MaxTableRatio refuses a run whose projected read reaches this share of the rows bronze holds.
    A pointer because 0 disables the check and absent means auto-etl's 1.0. */
  max_table_ratio?: number;
};
export type DomainWindowReloadConfig = {
  column?: string;
  from?: string;
  /** MinRatio refuses a window that comes back under this fraction of the rows it replaces. A
    pointer because 0 is meaningful (it disables the guard) and absent means auto-etl's 0.5. */
  min_ratio?: number;
  to?: string;
};
export type DomainIncrementalConfig = {
  created_column?: string;
  deleted_column?: string;
  /** FullLoadMinRatio rolls back a full load that lands under this share of the rows it replaces.
    Carried whatever else is set, since any table can resolve to a full load; a pointer because 0
    disables the guard and absent means auto-etl's 0.5. */
  full_load_min_ratio?: number;
  /** Set instead of UpdateColumn when the delta comes from a header table. Nested here rather than
    sitting beside Incremental because MergeKey is genuinely shared by every merge profile — this
    says only *how the delta is found*, not whether the table merges. */
  header_delta?: DomainSapHeaderDeltaConfig;
  lookback_minutes?: number;
  merge_key?: string;
  update_column?: string;
  /** Set instead of MergeKey/UpdateColumn: a window reload merges nothing, so it names no key. It
    lives on this struct despite the name because this is the one home for "how this table is
    loaded" — the struct predates the profile taxonomy, and a sibling field on TableDescription
    would give a table two places to answer the same question. */
  window?: DomainWindowReloadConfig;
};
export type DomainTableDescription = {
  audit_report?: DomainAuditReport;
  code?: string;
  columns?: DomainColumnDescription[];
  description?: string;
  foreign_keys?: DomainForeignKeyDescription[];
  incremental?: DomainIncrementalConfig;
  is_shared?: boolean;
  layer_id?: string;
  name?: string;
  not_null_columns?: string[];
  primary_keys?: string[];
  provider_database?: string;
  provider_project_name?: string;
  unique_columns?: string[];
};
export type AnalysisspecCreateAnalysisSpecRequest = {
  caller_email?: string;
  description?: string;
  instructions?: DomainInstructionItem[];
  message?: string;
  name?: string;
  project_id?: string;
  /** Query is an optional SQL definition supplied by the caller (today the MCP
    create_gold_table tool, from a query the user wrote). When present it is
    forwarded to auto-etl, which builds from it instead of generating the SQL
    from the instructions. Empty means the normal generation path. */
  query?: string;
  request_id?: string;
  slug?: string;
  source_tables?: DomainTableDescription[];
};
export type AnalysisspecAnalysisSpecLineageResponse = AnalysisSpecLineageResponse;
export type AnalysisspecAnalysisSpecProgressEvent = AnalysisSpecProgressEvent;
export type AnalysisspecAnalysisSpecProgressResponse = AnalysisSpecProgressResponse;
export type DomainEtlErrorCategory = ETLErrorCategory;
export type DomainEtlErrorConnector = ETLErrorConnector;
export type DomainEtlErrorReason = ETLErrorReason;
export type DomainEtlErrorRemediation = ETLErrorRemediation;
export type DomainEtlErrorInfo = ETLErrorInfo;
export type AnalysisspecAnalysisSpecStatusResponse = AnalysisSpecStatusResponse;
export type DomainInstructionPatchItem = {
  /** nil => new one */
  id?: string;
  text?: string;
};
export type DomainInstructionRequest = {
  analysis_spec_name?: string;
  instructions?: DomainInstructionPatchItem[];
};
export type DomainDeleteInstructionRequest = {
  analysis_spec_name?: string;
  instruction_ids?: string[];
};
export type AnalysisspecDeleteAnalysisSpecResponse = DeleteAnalysisSpecResponse;
export type AnalysisspecUpdateAnalysisSpecDescriptionRequest = {
  description?: string;
};
export type AnalysisspecBlockedSourceTablesResponse = BlockedSourceTablesResponse;
export type AnalysisspecReplaceAnalysisSpecDefinitionResponse = ReplaceAnalysisSpecDefinitionResponse;
export type AnalysisspecReplaceAnalysisSpecDefinitionRequest = {
  /** AcknowledgeBreakingChanges applies a query that drops columns saved dashboards, alerts or
    presentations still read; without it such a replace answers 409 BREAKS_DEPENDENTS. */
  acknowledge_breaking_changes?: boolean;
  description?: string;
  instructions?: string[];
  query: string;
  source_tables: DomainTableDescription[];
};
export type AnalysisspecAffectedDependent = AffectedDependent;
export type AnalysisspecDefinitionImpactResponse = DefinitionImpactResponse;
export type AnalysisspecDefinitionImpactRequest = {
  query: string;
};
export type AnalysisspecDependentDashboardsResponse = DependentDashboardsResponse;
export type AnalysisspecDuplicateAnalysisSpecResponse = DuplicateAnalysisSpecResponse;
export type AnalysisspecExportAnalysisSpecResponse = ExportAnalysisSpecResponse;
export type AnalysisspecRefreshAnalysisSpecDataResponse = RefreshAnalysisSpecDataResponse;
export type AnalysisspecRegenerateAnalysisSpecQueryResponse = RegenerateAnalysisSpecQueryResponse;
export type AnalysisspecRegenerateAnalysisSpecQueryRequest = {
  analysis_spec_name?: string;
  /** Instructions carries the updated instruction texts so auto-etl can use
    them when regenerating the SQL query. Without this, auto-etl would use
    stale knowledge from its own KnowledgeTable (set during initial creation)
    and the merge_graph would produce the same SQL, leaving the new spec
    version with the old code. */
  instructions?: DomainInstructionItem[];
};
export type AnalysisspecUpdateAnalysisSpecSourceTablesResponse = UpdateAnalysisSpecSourceTablesResponse;
export type AnalysisspecUpdateAnalysisSpecSourceTablesRequest = {
  source_tables?: DomainTableDescription[];
};
export const {
  useGetApiAnalysisSpecsExportDownloadQuery,
  useLazyGetApiAnalysisSpecsExportDownloadQuery,
  useGetApiProjectsByProjectIdAnalysisSpecsQuery,
  useLazyGetApiProjectsByProjectIdAnalysisSpecsQuery,
  usePostApiProjectsByProjectIdAnalysisSpecsMutation,
  useGetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugQuery,
  useLazyGetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugQuery,
  useGetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugLineageQuery,
  useLazyGetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugLineageQuery,
  useGetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugProgressQuery,
  useLazyGetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugProgressQuery,
  useGetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugStatusQuery,
  useLazyGetApiProjectsByProjectIdAnalysisSpecsBySlugAndSlugStatusQuery,
  usePutApiProjectsByProjectIdAnalysisSpecsInstructionsMutation,
  usePostApiProjectsByProjectIdAnalysisSpecsInstructionsMutation,
  useDeleteApiProjectsByProjectIdAnalysisSpecsInstructionsMutation,
  usePatchApiProjectsByProjectIdAnalysisSpecsInstructionsMutation,
  useDeleteApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameMutation,
  usePatchApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameMutation,
  useGetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameBlockedSourceTablesQuery,
  useLazyGetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameBlockedSourceTablesQuery,
  usePutApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDefinitionMutation,
  usePostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDefinitionImpactMutation,
  useGetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDependentDashboardsQuery,
  useLazyGetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDependentDashboardsQuery,
  usePostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDuplicateMutation,
  useGetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameExportQuery,
  useLazyGetApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameExportQuery,
  usePostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameRefreshMutation,
  usePostApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameRegenerateQueryMutation,
  usePatchApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameSourceTablesMutation,
} = injectedRtkApi;
